// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiSnackbarContent-root {
    background-color: var(--public-portal-card);
}

.MuiSnackbarContent-message {
    color: #636363;
}
`, "",{"version":3,"sources":["webpack://./src/components/cookieConsent/CookieConsent.css"],"names":[],"mappings":"AAAA;IACI,2CAA2C;AAC/C;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".MuiSnackbarContent-root {\n    background-color: var(--public-portal-card);\n}\n\n.MuiSnackbarContent-message {\n    color: #636363;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
